import React, { useRef, useEffect, useState } from 'react';
import { Row, Col, Space, Image } from "antd";
import clsx from 'clsx';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../../Shared/components/Icons/Date";
import { Typography, Tooltip, IconButton, FormControl, RadioGroup, FormControlLabel, Radio, Switch } from "@mui/material";
import { LineTable } from './LineTable';
import { SendReceiptForm } from './SendReceiptForm';
import { NavLink } from "react-router-dom";
import { currencyFormat, idNamingConversion } from "../../../../../../helpers/utilities";
import moment from 'moment';
import { CustomModal } from "../../../../../Shared/components/DeleteModal";
import { emptyValidation, customNumberValidation } from "../../../../../../helpers/validation";
import { useEventListener } from "../../../../../../helpers/useEventListener"
import infoMarkIcon from "../../../../../../assets/images/icon_actions/infoMark.svg";
import { CashReceiptDropDown } from './CashReceiptDropDown';
import { SelectedIcon, UnSelectedIcon } from "../../../../../Shared/components/Icons/selectedIcon";


export const RightSide = React.forwardRef((props, ref) => {
    const topBarRef = useRef(null);
    const bottomBarRef = useRef(null);

    const [height, setHeight] = useState('');
    const [receipt, setReceipt] = useState(false);

    const [rError, setRError] = useState({});

    const { error, customerDetails, returnProducts, handlePrint, customerApi, customObject, paymentProcess, handleNewSales, checkCRUDPermission, handleHeaderView, readLoader,
        salesType, changeHandler, form, classes, viewType, handleViewType, handlePaymentProcess, handleActiveInputs, handleSubmit, selected, headerView, status, loader, roleManagement, checkComponentPermission, } = props;

    const [rForm, setRForm] = useState({});

    useEffect(() => {
        if (topBarRef?.current) {
            let h = `calc(100% - ${topBarRef.current.clientHeight + bottomBarRef.current.clientHeight + 20}px)`;
            setHeight(h);
        }
    }, [topBarRef, form]);

    const handleReceipt = () => {
        setReceipt(true);
        setRForm({
            customerName: form?.customerName || form?.customer?.name,
            customerEmail: form?.customerEmail || form?.customer?.email || '',
            customerMobile: form?.customerMobile || form?.customer?.mobile
        });
    }


    const handleReceiptSubmit = () => {
        let emptyCustomerName = emptyValidation('Customer Name', rForm.customerName);
        let emptyCustomerEmail = emptyValidation('Customer Email', rForm.customerEmail);
        let emptyCustomerPhone = customNumberValidation('Customer Phone', rForm.customerMobile);
        setRError({});
        if (emptyCustomerName.isValid && emptyCustomerEmail.isValid && emptyCustomerPhone.isValid) {
        } else {
            setRError({
                customerName: emptyCustomerName?.errors || '',
                customerEmail: emptyCustomerEmail?.errors || '',
                customerMobile: emptyCustomerPhone?.errors || ''
            })
        }
    }

    const changeRHandler = (e) => {
        setRForm({
            ...rForm, [e.target.name]: e.target.value
        })
    }

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 82) { //ALT + R
            e.preventDefault();
            if (headerView) {
                if (receipt) {
                    handleReceiptSubmit();
                } else {
                    handleReceipt();
                }
            }
        }
    };

    useEventListener("keydown", handleKeyDown);

    return (
        <div className={clsx(classes.rightStoreSales, classes.heightFull)}>
            <div ref={topBarRef}>
                <div className={classes.rightStoreSalesTopBar} style={{ marginBottom: form?.salesType === 'Sale Return' && form?.type === 'create' ? 0 : 0 }}>
                    <Row gutter={40}>
                        {
                            viewType === 'barcode' && !paymentProcess && <Col xxl={4} xl={4} lg={4} md={5} sm={10} xs={24} className={clsx(classes.customerLabelNone)}>
                                <FormControl
                                    tabIndex={-1}
                                    className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.customRadioButtonRight)}
                                    variant={'standard'}
                                    fullWidth>
                                    <RadioGroup
                                        defaultValue="ACTIVE"
                                        aria-labelledby="demo-customized-radios"
                                        name="status"
                                        value={viewType || false}
                                        onChange={(e) => handleViewType(e.target.value)}
                                        id={idNamingConversion('viewType', 'storeSales', 'Radio')}>
                                        <FormControlLabel value="tile" control={<Radio
                                            checkedIcon={<UnSelectedIcon />}
                                            icon={<SelectedIcon />}
                                        />} label="Tile View"
                                        />
                                        <FormControlLabel value="keyboard" control={<Radio
                                            checkedIcon={<UnSelectedIcon />}
                                            icon={<SelectedIcon />}
                                        />} label="Keyboard View" />
                                        <FormControlLabel value="barcode" control={<Radio
                                            checkedIcon={<UnSelectedIcon />}
                                            icon={<SelectedIcon />}
                                        />} label="Barcode" />
                                    </RadioGroup>
                                </FormControl>
                            </Col>
                        }
                        <Col xxl={6} xl={6} lg={6} md={8} sm={8} xs={24} className={clsx(classes.customerLabelNone)}>
                            {
                                headerView ?
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.serialNo || '---'}</Typography>
                                    : <AutoCompleteComponent
                                        customLabel={"Customer"}
                                        heads={[{ 'key': 'serialNo', 'name': 'Customer ID' }, { 'key': 'name', 'name': 'Customer name' }]}
                                        details={customerDetails}
                                        parentValue={customObject(customerDetails, form?.customerId)}
                                        position={"bottom"}
                                        variant={'outlined'}
                                        disabled={form?.isReturnWithReceipt}
                                        searchType={(s) => customerApi(s)}
                                        onChange={(data) => changeHandler(data, 'customerId')}
                                        parentError={error?.customerId || false}
                                    />
                            }
                            <div className={clsx(classes.dateAdjust)}>
                                {
                                    headerView ? <><Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Invoice Date </Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.invoiceDate ? moment(form?.invoiceDate).format('DD MMM YYYY') : '---'}</Typography></>
                                        :
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                className={clsx(classes.margin20t)}
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                minDate={new Date()}
                                                allowKeyboardControl={false}
                                                value={form?.invoiceDate || null}
                                                label="Invoice Date"
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    },
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        error: error?.invoiceDate && true,
                                                        helperText: error?.invoiceDate
                                                    },
                                                }}
                                                format="dd MMM yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError) {
                                                        changeHandler(new Date(), 'invoiceDate');
                                                    } else {
                                                        changeHandler(newValue, 'invoiceDate');
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                }
                            </div>
                        </Col>
                        <Col xxl={viewType === 'barcode' ? 14 : 18} xl={viewType === 'barcode' ? 14 : 18} lg={viewType === 'barcode' ? 14 : 18}
                            md={viewType === 'barcode' ? 11 : 16} sm={viewType === 'barcode' ? 24 : 16} xs={viewType === 'barcode' ? 24 : 24}>
                            <Row gutter={10}>
                                <Col span={12}>
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, classes.marginRight10, 'MuiInputLabel-shrink')
                                        }}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => changeHandler(!form?.includeGst, 'includeGst')}
                                            checked={form?.includeGst || false}
                                        />}
                                        label="GST Inv."
                                        labelPlacement="start"
                                        disabled={form?.includeDisabled || headerView}
                                        className={clsx(classes.marginLeft0)}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.textAlignRight, classes.bold)}>
                                        <span className={classes.receipt}>{form?.cashReceiptNumber}</span>
                                    </Typography>
                                </Col>
                            </Row>
                            <div className={clsx(classes.storeSalesTotals, classes.margin20t)}>
                                <Row gutter={10}>
                                    <Col xxl={5} xl={5} lg={5} md={8} sm={8} xs={8}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                            <span>Total Discount</span>
                                            <Tooltip
                                                classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                title={'Sum of all product line discount amounts'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                <IconButton>
                                                    <Image src={infoMarkIcon} preview={false} />
                                                </IconButton>
                                            </Tooltip>
                                        </Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.discount ? '₹ ' + currencyFormat(form?.discount) : '---'}</Typography>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={5} md={8} sm={8} xs={8}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Net Amount</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.netAmount ? '₹ ' + currencyFormat(form?.netAmount) : '---'}</Typography>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={5} md={8} sm={8} xs={8}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>GST Amount</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.gstAmount ? '₹ ' + currencyFormat(form?.gstAmount) : '---'}</Typography>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={5} md={8} sm={8} xs={8}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                            <span>Bill Discount</span>
                                            <Tooltip
                                                classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                title={'Discretionary discount amount given by owner to customer'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                <IconButton>
                                                    <Image src={infoMarkIcon} preview={false} />
                                                </IconButton>
                                            </Tooltip></Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.invoiceAmount ? '₹ ' + currencyFormat(parseFloat(form?.discountAmount || 0)) : '---'}</Typography>
                                    </Col>
                                    <Col span={4}>
                                        <div>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)} style={{ padding: 0, whiteSpace: "nowrap" }}>Invoice Amount</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.invoiceAmount ? '₹ ' + currencyFormat(parseFloat(form?.invoiceAmount || 0)) : '---'}</Typography>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className={classes.rightStoreSalesSecondBar}>
                    <Row>
                        <Col span={6}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Total Quantity <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14, classes.padding10L)}>
                                {
                                    form?.isReturnWithReceipt ?
                                        selected?.filter((el) => { return returnProducts.find(e => e === el.id && !el.isReturned) }).reduce((a, v) => a = parseFloat(a) + parseFloat(v?.quantity || 0), 0) : selected.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.quantity || 0), 0)
                                }
                            </span></Typography>
                        </Col>
                        <Col span={6}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13, classes.descEllipsis)} style={{ whiteSpace: "nowrap" }}><span>Order Taker</span> <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14, classes.padding10L)}>{form?.storeSalesUser?.name || '---'}</span></Typography>
                        </Col>
                        <Col span={12} className={clsx(classes.rightStoreSalesTable, classes.customerLabelNone, { [classes.disabled]: paymentProcess })}>
                            {
                                form?.salesType === 'Sale Return' && form?.type === 'create' && <CashReceiptDropDown {...props} />
                            }
                        </Col>
                    </Row>
                </div>
            </div>
            <div className={classes.rightStoreSalesTable} style={{ height: height }}>
                {
                    readLoader ? <div style={{ textAlign: "center" }}>
                        <div className={classes.loadMoreCircle} style={{ marginTop: 10 }}></div>
                    </div> :
                        <LineTable {...props} />
                }

            </div>
            <div ref={bottomBarRef} className={clsx(classes.rightStoreSalesBottomBar, classes.textAlignRight)}>
                <Space direction="horizontal" align="center" size={[10, 10]}>
                    {
                        (paymentProcess && !headerView) && <NavLink to={'#'} id={idNamingConversion('Back', 'storeSales', 'Button')} onClick={() => { handlePaymentProcess(false); handleActiveInputs('') }} className={classes.AddMoreBtn}>Back</NavLink>
                    }
                    {
                        roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'New Sales') &&
                        <NavLink to={'#'} id={idNamingConversion('New Sales', 'storeSales', 'Button')} onClick={() => handleNewSales()} className={classes.AddMoreBtn}>{form?.salesType === 'Sale' ? 'New Sales' : 'New Sales Return'}</NavLink>
                    }
                    {
                        roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'Print') &&
                        <NavLink to={'#'} id={idNamingConversion('Print', 'storeSales', 'Button')} className={clsx(classes.AddMoreBtn, { [classes.disabled]: selected?.length === 0 || (form?.isReturnWithReceipt && returnProducts?.length === 0) })} onClick={() => handlePrint(true)}>Print</NavLink>
                    }
                    {/* {
                        roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'Close') &&
                        <NavLink to={'/sales/sales-management/store-sales'} className={classes.AddMoreBtn}>Close</NavLink>
                    } */}
                    {
                        headerView ? <>
                            {
                                roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'Send Receipt') &&
                                <NavLink to={'#'} id={idNamingConversion('Send Receipt', 'storeSales', 'Button')} onClick={() => handleReceipt()} className={classes.AddMoreBtn}>Send Receipt</NavLink>
                            }

                        </> : ''
                    }
                    {
                        headerView ? <>
                            {
                                status === 'CREATED' && roleManagement !== '' && checkCRUDPermission('Store Sales', 'edit', 'Sales') &&
                                <NavLink to={'#'} id={idNamingConversion('Edit', 'storeSales', 'Button')} onClick={() => handleHeaderView(false)} className={clsx(classes.AddMoreBtn)}>Edit</NavLink>
                            }
                        </> : <>

                            <NavLink to={'#'}
                                id={idNamingConversion('Save', 'storeSales', 'Button')}
                                onClick={() => {
                                    if (paymentProcess) {
                                        handleSubmit('CREATED', paymentProcess);
                                    } else {
                                        handleSubmit('CREATED')
                                    }
                                }} className={clsx(classes.modalBtn, { [classes.loadingA]: loader }, { [classes.disabled]: selected?.length === 0 || (form?.isReturnWithReceipt && returnProducts?.length === 0) })}>{form?.id ? 'Update' : 'Save'}</NavLink>

                            {
                                paymentProcess ? <>
                                    {roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'Confirm') &&
                                        <NavLink to={'#'}
                                            id={idNamingConversion('Confirm', 'storeSales', 'Button')}
                                            onClick={() => handleSubmit('CONFIRMED', paymentProcess)} className={clsx(classes.modalBtn, { [classes.disabled]: (selected?.length === 0 || (!form?.amountReceived && salesType === 'Sale') || (form?.isReturnWithReceipt && returnProducts?.length === 0)) }, { [classes.loadingA]: loader })}>{salesType === 'Sale Return' ? 'Refund' : 'Confirm'}</NavLink>
                                    }
                                </> : <>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'Process Payment') &&
                                        <NavLink to={'#'} onClick={() => handlePaymentProcess(true)}
                                            id={idNamingConversion('Process Payment', 'storeSales', 'Button')}
                                            className={clsx(classes.modalBtn, { [classes.disabled]: selected?.length === 0 || (form?.isReturnWithReceipt && returnProducts?.length === 0) }, { [classes.loadingA]: loader })}>
                                            Process Payment
                                        </NavLink>
                                    }
                                </>
                            }
                        </>
                    }
                </Space>
            </div>
            <CustomModal
                onClose={(v) => { setReceipt(v); setRError({}); setRForm({}) }}
                yesButton={'OK'}
                noButton={'Cancel'}
                title={'Send Receipt'}
                visible={receipt}
                onOpen={() => handleReceiptSubmit()}
                text={
                    <SendReceiptForm
                        changeHandler={(e) => changeRHandler(e)}
                        error={rError}
                        form={rForm}
                    />
                }
            />
        </div>
    )
})